import { useStaticQuery, graphql } from 'gatsby'
import { useBlogAuthors } from '@helpers-blog'

// :::: GET all the articles and returning Authors by selected article ::::
export const getSelectedBlogAuthors = title => {
  const { blog, event , video } = useStaticQuery(allBlogsQuery)
  const list=[...blog.nodes,...event.nodes , ...video.nodes]
  const selectedAuthors = list.filter(article => article.title === title)
  return selectedAuthors.length !== 0 && selectedAuthors[0].authors
}

const allBlogsQuery = graphql`
  query {
    blog: allStrapiBlog {
      nodes {
        id
        title
        authors {
          id
          name
          title
          slug
          social {
            name
            url
          }
        }
      }
    }
    event: allStrapiEvent {
      nodes {
        id
        title
        
      }
    }
    video: allStrapiVideo {
      nodes {
        id
        title
        authors {
          id
          name
          title
          slug
          social {
            name
            url
          }
        }
      }
    }
  }
`
// :::: Attach thumbnail ::::
export const attachThumbnail = authors => {
  authors.forEach(author => {
    author['thumbnail'] = useBlogAuthors().find(
      authorWithThumbnail => authorWithThumbnail.name === author.name
    ).thumbnail
  })
}
